import config from 'src/config';

/**
 * Sets the logged in user
 */
const setLoggedInUser = (user) => {
  localStorage.setItem(config.STORAGE_KEY_USER, JSON.stringify(user));
};

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
  const user = localStorage.getItem(config.STORAGE_KEY_USER);
  if (user) {
    if (typeof user == 'object') {
      return user;
    }
    const parsedUserData = JSON.parse(user);
    const newData = {
      ...parsedUserData,
      user: {
        ...parsedUserData,
        id: parseInt(parsedUserData.user.id),
      },
    };
    return newData;
  }
  return null;
};

export { setLoggedInUser, getLoggedInUser };
